<template>
  <div class="sign-container">
    <!-- 1. PDF 预览区域 -->
    <div class="pdf-viewer">
      <h3>合同预览</h3>
      <div class="pdf_div" @scroll="handleScroll" ref="div_pdf">
        <pdf
          ref="pdf"
          :page="item"
          :src="pdfUrl"
          v-for="item in pageTotal"
          :key="item"
          class="pdf-frame"
        >
        </pdf>
      </div>
    </div>

    <!-- 2. 签名操作区域 -->
    <div>
      <!-- 点击此按钮触发全屏签名 -->
      <div v-if="signatureData" class="btn-group">
        <el-button type="success" @click="signature" :disabled="!isBottom"
          >提交</el-button
        >
        <el-button type="success" @click="signature" :disabled="!isBottom"
          >重新签名</el-button
        >
      </div>
      <div class="btn-group" v-else>
        <el-button type="success" @click="signature" :disabled="!isBottom"
          >开始签名</el-button
        >
      </div>
    </div>
    <!-- 签名数据 -->
    <FullverticalScreenSign
      ref="fullScreenSign"
      :visible="showSignModal"
      @confirm="handleSignature"
      @update:visible="showSignModal = $event"
      v-if="isMobile"
    />
    <FullScreenSign
      ref="fullScreenSign"
      :visible="showSignModal"
      @confirm="handleSignature"
      @update:visible="showSignModal = $event"
      v-else
    />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import pdf from 'vue-pdf';
import { PDFDocument } from 'pdf-lib';
import FullScreenSign from './screenSign/horizontal.vue';
import FullverticalScreenSign from './screenSign/vertical.vue';
import hetong from './TerminateAgreement.pdf';

@Component({
  name: 'H5SignContract',
  components: {
    pdf,
    FullScreenSign,
    FullverticalScreenSign,
  },
})
export default class H5SignContract extends Vue {
  // --- Data 属性定义 ---
  pdfUrl: string | ArrayBuffer = hetong;
  tracePdf: any = hetong;
  ctx: CanvasRenderingContext2D | null = null;
  isDrawing = false;
  currentPage = 1;
  pageCount = 0;
  pageTotal = 0;
  showSignModal = false;
  signatureData: any = null;
  isMobile = false;
  isBottom = false;

  // --- 生命周期钩子 ---
  mounted() {
    this.getNumPages(this.pdfUrl as string);
    
    this.$nextTick(() => {
      // 模拟滚动事件以触发初始状态判断
      this.handleScroll({ target: this.$refs.div_pdf } as unknown as Event);
    });

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
      console.log('当前是手机/平板');
      this.isMobile = true;
    } else {
      console.log('当前是电脑');
      this.isMobile = false;
    }
  }

  // --- Methods 方法定义 ---
  signature(): void {
    this.showSignModal = true;
    this.$nextTick(() => {
      (this.$refs.fullScreenSign as any).initCanvas();
    });
  }

  handleScroll(e: Event): void {
    console.log('滚动事件触发', e);
    const re = this.$refs.div_pdf;
    console.log('滚动事件触发', re);
    
    const container = e.target as HTMLElement;
    const scrollTop = container.scrollTop;
    const clientHeight = container.clientHeight;
    const scrollHeight = container.scrollHeight;

    // 加上容错值防止小数像素导致无法精确相等
    if (scrollTop + clientHeight >= scrollHeight - 1) {
      if (!this.isBottom) {
        console.log('已经滚动到底部了！');
        this.isBottom = true;
      }
    }
  }

  handleSignature(data: any): void {
    this.signatureData = data;
    this.submitSign();
    console.log('签名数据', this.signatureData);
    this.$message.success('签名已保存，请点击确认签署完成合同');
  }

  getNumPages(url: string | ArrayBuffer): void {
    const loadingTask = pdf.createLoadingTask(url);
    loadingTask.promise
      .then((pdfDoc: any) => {
        console.log('获取PDF页数成功', pdfDoc.numPages);
        this.pageTotal = pdfDoc.numPages;
      })
      .catch((err: any) => {
        console.error('获取PDF页数失败', err);
      });
  }

  pdfLoaded(): void {
    const pdfRef = this.$refs.pdf as any;
    if (pdfRef && pdfRef.pdf) {
      this.pageCount = pdfRef.pdf.numPages;
    } else {
      console.warn('PDF 实例尚未准备好');
    }
  }

  loadedProgress($event: any): void {
    console.log('加载进度', $event);
  }

  pdfError($event: any): void {
    console.error('PDF加载失败', $event);
    this.$message.error('合同文件加载失败，请检查网络或文件格式');
  }

  // --- Canvas 初始化 ---
  initCanvas(): void {
    const canvas = this.$refs.signCanvas as HTMLCanvasElement;
    const parent = canvas.parentElement!;

    const dpr = window.devicePixelRatio || 1;
    const rect = parent.getBoundingClientRect();

    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    canvas.style.width = `${rect.width}px`;
    canvas.style.height = `${rect.height}px`;

    this.ctx = canvas.getContext('2d')!;
    this.ctx.scale(dpr, dpr);

    this.ctx.lineWidth = 3;
    this.ctx.lineCap = 'round';
    this.ctx.strokeStyle = '#000000';

    this.bindEvents(canvas);
  }

  // --- 绑定绘图事件 ---
  bindEvents(canvas: HTMLCanvasElement): void {
    canvas.addEventListener('mousedown', this.startDraw);
    canvas.addEventListener('mousemove', this.draw);
    canvas.addEventListener('mouseup', this.endDraw);
    canvas.addEventListener('mouseout', this.endDraw);

    canvas.addEventListener(
      'touchstart',
      (e: TouchEvent) => {
        e.preventDefault();
        this.startDraw(e.changedTouches[0] as unknown as MouseEvent);
      },
      { passive: false },
    );

    canvas.addEventListener(
      'touchmove',
      (e: TouchEvent) => {
        e.preventDefault();
        this.draw(e.changedTouches[0] as unknown as MouseEvent);
      },
      { passive: false },
    );

    canvas.addEventListener('touchend', this.endDraw);
  }

  // --- 绘图核心逻辑 ---
  getPos(e: MouseEvent): { x: number; y: number } {
    const canvas = this.$refs.signCanvas as HTMLCanvasElement;
    const rect = canvas.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  }

  startDraw(e: MouseEvent): void {
    this.isDrawing = true;
    const pos = this.getPos(e);
    this.ctx!.beginPath();
    this.ctx!.moveTo(pos.x, pos.y);
  }

  draw(e: MouseEvent): void {
    if (!this.isDrawing) return;
    const pos = this.getPos(e);
    this.ctx!.lineTo(pos.x, pos.y);
    this.ctx!.stroke();
  }

  endDraw(): void {
    if (!this.isDrawing) return;
    this.isDrawing = false;
    this.ctx!.closePath();
  }

  clearSignature(): void {
    const canvas = this.$refs.signCanvas as HTMLCanvasElement;
    this.ctx!.clearRect(0, 0, canvas.width, canvas.height);
  }

  // --- 核心：合成 PDF 并提交 ---
  async submitSign(): Promise<void> {
    try {
      const signatureImage = this.signatureData;
      const pdfBytes = await fetch(this.tracePdf as string).then((res) => res.arrayBuffer());

      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      const lastPage = pages[pages.length - 1];

      const signatureImg = await pdfDoc.embedPng(signatureImage);

      const { width, height } = lastPage.getSize();
      const imgWidth = 150;
      const imgHeight = 50;

      lastPage.drawImage(signatureImg, {
        x: width - 320,
        y: 350,
        width: imgWidth,
        height: imgHeight,
      });

      const now = new Date();
      const year = String(now.getFullYear());
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');

      lastPage.drawText(year, {
        x: width - 460,
        y: 340,
        size: 14,
      });
      lastPage.drawText(month, {
        x: width - 412,
        y: 340,
        size: 14,
      });
      lastPage.drawText(day, {
        x: width - 380,
        y: 340,
        size: 14,
      });

      const signedPdfBytes = await pdfDoc.save();
      const blob = new Blob([signedPdfBytes], { type: 'application/pdf' });
      console.log(blob);

      this.pdfUrl = URL.createObjectURL(blob);
      console.log(this.pdfUrl);
    } catch (error) {
      console.error('PDF 合成失败:', error);
    }
  }
}
</script>

<style scoped>
.pdf-frame {
  width: 100%;
  height: 100%;
  /* 移除 height，让内容自然撑开，或者根据需要设置 */
  /* min-height: 400px; */
  border: 1px solid #ddd;
  background: #f0f0f0;
}
.page-control {
  margin-top: 10px;
  text-align: center;
}
.page-control button {
  padding: 5px 10px;
  margin: 0 5px;
}
.sign-container {
  /* max-width: 600px; */
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  background: #f5f5f5;
  min-height: 100vh;
  box-sizing: border-box;
}

.pdf-viewer {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  height: 80vh;

  /* min-height: 90vh; */
}

.pdf_div {
  height: 75vh;
  overflow-y: auto;
}

.pdf-viewer h3 {
  margin-top: 0;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.pdf-frame {
  width: calc(100vw - 62px);
  height: calc(100vw * 1.41421356 - 62px * 1.41421356);

  border: 1px solid #ddd;
  border-radius: 4px;
}

.action-area {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.action-area h3 {
  margin-top: 0;
  color: #333;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.canvas-wrapper {
  width: 100%;
  height: 200px;
  border: 2px dashed #ccc;
  border-radius: 4px;
  overflow: hidden;
  background: #fafafa;
  touch-action: none; /* 禁止触摸板默认滚动行为 */
}

canvas {
  display: block;
  width: 100%;
  height: 100%;
}

.tips {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  text-align: center;
}

.btn-group {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

button {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

.btn-clear {
  background: #ff4d4f;
  color: white;
}
.btn-clear:hover {
  background: #ff7875;
}

.btn-submit {
  background: #52c41a;
  color: white;
}
.btn-submit:hover {
  background: #73d13d;
}
</style>